import React from 'react'
import ListItemNormal from './ListItemNormal'
import ListItemModal from './ListItemModal'

export const detail = (contact) => {
	let contact_detail = ''
	if (contact?.phones && contact?.email) {
		contact_detail =
			contact?.phones[0].number + ' | ' + contact?.email[0].address
	} else if (contact?.phones) {
		contact_detail = contact?.phones[0].number
	} else if (contact?.email) {
		contact_detail = contact?.email[0].address
	} else {
		contact_detail = ''
	}

	return contact_detail
}

export default (props) =>
	props.modal ? <ListItemModal {...props} /> : <ListItemNormal {...props} />
